import { useEffect, useState } from "react";
import { useAuth } from "../auth/AuthContext";
import { inApp } from "../lib/inApp";
import { inAppLimitLine, type LimitHit, subscribeUpgrade } from "../lib/upgrade";
import { flashsuitePages } from "./FlashsuiteMenu";

/**
 * The one line a plan limit gets when it stops an action, with the button to Flashsuite, where the plan
 * is changed (Flashsuite ACCOUNTS.md section 8). The API client raises it on any 402, so no screen wires
 * it. It stays until closed or the next limit replaces it. Inside the phone app it says the fact only,
 * never how to get more (flashsuite-phone docs/APP-MODE.md section 2).
 */
export function LimitNotice() {
  const [hit, setHit] = useState<LimitHit | null>(null);
  const { user, flashsuite } = useAuth();
  const pages = flashsuitePages(flashsuite);
  useEffect(() => subscribeUpgrade(setHit), []);
  if (!hit) return null;
  const app = inApp();
  const start = hit.reason === "subscription";
  const href = app ? undefined : start ? pages?.start : pages?.billing;
  return (
    <div className="sbanner bbar brass" role="status">
      <span className="ic">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M12 9v4M12 17h.01M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z" />
        </svg>
      </span>
      <div className="sbanner-copy">
        <div className="bt">{app ? inAppLimitLine(hit.reason, hit.message, user?.workspace_name) : hit.message}</div>
      </div>
      <div className="act">
        {href ? (
          <a className="abtn" href={href}>
            {start ? "Choose a plan" : "Open Billing"}
          </a>
        ) : null}
        <button type="button" className="sx" aria-label="Close" onClick={() => setHit(null)}>
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M6 6l12 12M18 6 6 18" />
          </svg>
        </button>
      </div>
    </div>
  );
}
